import * as React from "react";
import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";
const inputVariants = cva("flex h-10 w-full px-3 py-2 text-sm text-foreground ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-50 transition-colors duration-200", {
  variants: {
    variant: {
      default: "bg-input/50 rounded-lg border border-input-border hover:bg-input/70",
      underline: "bg-transparent border-b border-section-border rounded-none focus-visible:ring-0 focus-visible:ring-transparent"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement>, VariantProps<typeof inputVariants> {}
const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  variant,
  ...props
}, ref) => {
  return <input type={type} className={cn(inputVariants({
    variant
  }), className)} ref={ref} {...props} />;
});
Input.displayName = "Input";
export { Input };